import { useState } from "react";
import { BrowserRouter, Routes, Route, NavLink } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contracts from "./pages/Contracts";
import Quotes from "./pages/Quotes";
import Validate from "./pages/Validate";
import Admin from "./pages/Admin";
import { API_URL } from "./api";
import "./App.css";

const navItems = [
  { to: "/", label: "Inicio" },
  { to: "/nosotros", label: "Nosotros" },
  { to: "/cotizacion", label: "Cotización" },
  { to: "/contratos", label: "Contratos" },
  { to: "/admin", label: "Admin" },
];

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <BrowserRouter>
      <div className="flex min-h-screen flex-col">
        <header className="sticky top-0 z-50 border-b border-orange-400/20 bg-black/80 backdrop-blur-lg">
          <nav className="mx-auto flex max-w-7xl items-center gap-6 px-4 py-3 md:px-8">
            <img
              src={`${API_URL}/images/logo-djcarbajal.png`}
              alt="DJ Carbajal"
              className="h-10 w-auto"
              onError={(e) => { e.currentTarget.style.display = "none"; }}
            />
            <span className="text-lg font-black uppercase tracking-wider text-orange-400">DJ CARBAJAL</span>
            <button
              className="ml-auto block md:hidden text-orange-400 focus:outline-none"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              ☰
            </button>
            <div
              className={`ml-auto flex-col gap-4 text-sm font-medium md:flex md:flex-row ${menuOpen ? "flex" : "hidden"}`}
            >
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    `transition-colors hover:text-orange-300 ${isActive ? "text-orange-400" : "text-orange-100/80"}`
                  }
                  onClick={() => setMenuOpen(false)}
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          </nav>
        </header>

        <main className="mx-auto w-full max-w-7xl flex-1 px-4 py-8 text-orange-50 md:px-8">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/nosotros" element={<About />} />
            <Route path="/cotizacion" element={<Quotes />} />
            <Route path="/contratos" element={<Contracts />} />
            <Route path="/validar/:code" element={<Validate />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>

        <footer className="border-t border-orange-400/10 py-6 text-center text-xs text-orange-100/50">
          &copy; {new Date().getFullYear()} DJ CARBAJAL &mdash; Feel the sound
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;
